export const THRESHOLD_STATUS = 90
